<template>
<div class='pagination'>
    <a-pagination
        :total="total" 
        :itemRender="itemRender" 
        @change="onChange"
        :current="current" 
        :pageSize="pageSize"
    />
</div>
</template>
<script>
import { Pagination } from 'ant-design-vue'

export default {
    components: {
        [Pagination.name]: Pagination
    },
    data() {
        return {
            current: 1
        }
    },
    props: {
        total: {
            type: Number,
        },
        pageSize: {
            type: Number,
            default: 10
        }
    },
    methods: {
        itemRender(current, type, originalElement) {
            if (type === 'prev') {
                return <a class="pagePN"><span class="triangleLeft"></span>上一页</a>;
            } else if (type === 'next') {
                return <a class="pagePN">下一页<span class="triangleRight"></span></a>;
            }
            return originalElement;
        },
        onChange(current) {
            this.current = current;
            this.$emit('change', current)
        },
    }
}
</script>
<style lang="scss">
$size-normal: 14px;
.pagination{
    display: flex;
    flex-direction: column;
    text-align: right;

    .ant-pagination  {
        box-sizing: border-box;
        padding-right: 20px;

        .ant-pagination-total-text {
            order: -2;
            font-size: $size-normal;
            color: $primary-color;
            letter-spacing: 0;  
        }

        .ant-pagination-prev,
        .ant-pagination-next {
            background: #FFFFFF;
            border: 1px solid $text-gray-db ;
            width: 64px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #666;
            letter-spacing: 0;
            text-align: center;
            border-radius: 0; 
            // margin-right: 10px;
        }
        .ant-pagination-prev{
            margin-right: 10px;
        }
        .ant-pagination-next{
            margin-left: 5px;
        }

        .ant-pagination-item  {
            background: #FFFFFF;
            border: 1px solid #DBDBDB;
            height: 28px;
            // line-height: 28px;
            color: $color-999;
            letter-spacing: 0;
            font-size: $size-normal;
            letter-spacing: 0;
            text-align: center;
            border-radius: 0;
            margin-right: 5px;
            text-align: center;
        }

        .ant-pagination-item-active {
            font-size: $size-normal;
            letter-spacing: 0;
            text-align: center;
            border: 0;
            border: 1px solid $primary-color;
        }

        .ant-pagination-options {
            order: -1;
            border-radius: 0;
            flex: 1;

            .ant-select-selection {
                border-radius: 0;
            }
        }

        .ant-pagination-disabled  {
            .pagePN:hover {
                .triangleLeft {
                    border-right: 5px solid #cccccc !important;
                }

                .triangleRight {
                    border-left: 5px solid #cccccc !important;
                }
            }
        }

        .pagePN:hover {
            .triangleLeft {
                border-right: 5px solid $primary-color !important;
            }

            .triangleRight {
                border-left: 5px solid $primary-color !important;
            }
        }

        .triangleLeft {
            margin-right: 4px;
            display: inline-block;
            position: relative;
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-right: 5px solid #cccccc;
        }

        .triangleRight {
            margin-left: 4px;
            display: inline-block;
            position: relative;
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #cccccc;
        }

        .ant-pagination-options-quick-jumper {
            input {
                border-radius: 0;
                height: 28px;
            }
        }
    }
}

</style>
